import cx from 'classnames';

type Props = {
  setDisplaySubscriptionPrice: React.Dispatch<React.SetStateAction<boolean>>;
  displaySubscriptionPrice: boolean;
  subscriptionText: string;
  buyNowText: string;
};

const PriceRowSwitcher = ({
  setDisplaySubscriptionPrice,
  displaySubscriptionPrice,
  subscriptionText,
  buyNowText,
}: Props) => {
  return (
    <div
      className={cx(
        'mt-2 flex items-center justify-around border-lilac-5 bg-lilac-5',
        'justify-center rounded-lg border-2  text-black',
      )}
    >
      <button
        onClick={() => setDisplaySubscriptionPrice(true)}
        type="button"
        className={cx(
          'text-md rounded-lg py-4 md:px-10',
          `${
            displaySubscriptionPrice
              ? 'flex-1 bg-grey-90 text-lilac-5'
              : 'flex-1 bg-lilac-5 text-grey-90'
          }`,
        )}
      >
        {subscriptionText}
      </button>
      <button
        onClick={() => setDisplaySubscriptionPrice(false)}
        type="button"
        className={cx(
          'text-md rounded-lg py-4 md:px-10',
          `${
            displaySubscriptionPrice
              ? 'flex-1 bg-lilac-5 text-grey-90'
              : 'flex-1 bg-grey-90 text-lilac-5'
          }`,
        )}
      >
        {buyNowText}
      </button>
    </div>
  );
};
export default PriceRowSwitcher;
